import { countConversationsResolved } from '../queries/countConversationsResolved'

export const totalConversationsResolvedGauge = {
  description: 'Total amount of conversations marked as closed.',
  queries: [countConversationsResolved],
  title: 'Resolutions',
}
